import replaceAt from '@/helpers/replaceAt'

export default function (dateStr) {
  if (!dateStr) return
  if (dateStr.length === 19) {
    dateStr = replaceAt(dateStr, 10, 'T')
    return new Date(dateStr + '.000Z')
  }
  return new Date(dateStr)
}
